import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=dfb1876a&lang=pug&"
import script from "./Fullscreen.vue?vue&type=script&lang=ts&"
export * from "./Fullscreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports